// APP
export const APP_INIT_START = 'APP_INIT_START';
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS';
export const APP_INIT_FAILED = 'APP_INIT_FAILED';
export const FORCED_LOGOUT_START = 'FORCED_LOGOUT_START';
export const FORCED_LOGOUT_SUCCESS = 'FORCED_LOGOUT_SUCCESS';
export const FORCED_LOGOUT_FAILED = 'FORCED_LOGOUT_FAILED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

// SADATA for location
export const ADD_SAD = 'ADD_SAD';

// ALERTS
export const ADD_ALERT_TO_QUEUE = 'ADD_ALERT_TO_QUEUE';
export const REMOVE_ALERT_DATA_FROM_QUEUE = 'REMOVE_ALERT_DATA_FROM_QUEUE';

// LOCATIONS
export const ADD_LOCATION_TO_QUEUE = 'ADD_LOCATION_TO_QUEUE';
export const CLEAR_LOCATION_ERROR = 'CLEAR_LOCATION_ERROR';
export const FETCH_LOCATION_START = 'FETCH_LOCATION_START';
export const FETCH_LOCATION_SUCCESS = 'FETCH_LOCATION_SUCCESS';
export const FETCH_LOCATION_FAILED = 'FETCH_LOCATION_FAILED';
export const REMOVE_ALL_NUMS = 'REMOVE_ALL_NUMS';
export const REMOVE_NUM_FROM_QUEUE = 'REMOVE_NUM_FROM_QUEUE';
export const SET_CALLER_ID = 'SET_CALLER_ID';
export const SET_EXPIRED_TIME = 'SET_EXPIRED_TIME';
export const SET_INITIALIZED_HERMES_STATE = 'SET_INITIALIZED_HERMES_STATE';
export const TOGGLE_NUM_LOCATIONS = 'TOGGLE_NUM_LOCATIONS';
export const SET_JURISDICTION_RG_ADDRESS_START =
  'SET_JURISDICTION_RG_ADDRESS_START';
export const SET_JURISDICTION_RG_ADDRESS_SUCCESS =
  'SET_JURISDICTION_RG_ADDRESS_SUCCESS';
export const SET_JURISDICTION_RG_ADDRESS = 'SET_JURISDICTION_RG_ADDRESS';
export const SET_JURISDICTION_RG_ADDRESS_ERROR =
  'SET_JURISDICTION_RG_ADDRESS_ERROR';

// PSAPS
export const GET_PSAP_INFO_START = 'GET_PSAP_INFO_START';
export const GET_PSAP_INFO_SUCCESS = 'GET_PSAP_INFO_SUCCESS';
export const GET_PSAP_INFO_FAILED = 'GET_PSAP_INFO_FAILED';
export const SET_PSAP_INFO = 'SET_PSAP_INFO';
export const SET_CURRENT_GEOFENCE = 'SET_CURRENT_GEOFENCE';
export const SET_GEOFENCES = 'SET_GEOFENCES';

// MEDICALERT
export const REMOVE_MA = 'REMOVE_MA';
export const SET_CANDIDATES = 'SET_CANDIDATES';
export const SET_CURRENT_MAFID = 'SET_CURRENT_MAFID';
export const SET_MA_LOADING_STATE = 'SET_MA_LOADING_STATE';
export const SET_MAFID_TO_QUERY = 'SET_MAFID_TO_QUERY';
export const SET_PROFILE = 'SET_PROFILE';

// SPATIAL LAYERS
export const ADD_DYNAMIC_LAYER = 'ADD_DYNAMIC_LAYER';
export const CLEAR_CHECKED_LAYERS = 'CLEAR_CHECKED_LAYERS';
export const CLEAR_RAD_SESSION = 'CLEAR_RAD_SESSION';
export const DEACTIVATE_SPATIAL_LAYER = 'DEACTIVATE_SPATIAL_LAYER';
export const FETCH_CRG_DEEPLINK_START = 'FETCH_CRG_DEEPLINK_START';
export const FETCH_CRG_DEEPLINK_SUCCESS = 'FETCH_CRG_DEEPLINK_SUCCESS';
export const FETCH_CRG_DEEPLINK_FAILED = 'FETCH_CRG_DEEPLINK_FAILED';
export const FETCH_RAD_SESSION_START = 'FETCH_RAD_SESSION_START';
export const FETCH_RAD_SESSION_SUCCESS = 'FETCH_RAD_SESSION_SUCCESS';
export const FETCH_RAD_SESSION_FAILED = 'FETCH_RAD_SESSION_FAILED';
export const FORCE_STATIC_LAYER_ON = 'FORCE_STATIC_LAYER_ON';
export const FORCE_STATIC_LAYER_OFF = 'FORCE_STATIC_LAYER_OFF';
export const GET_SPATIAL_LAYERS_START = 'GET_SPATIAL_LAYERS_START';
export const GET_SPATIAL_LAYERS_SUCCESS = 'GET_SPATIAL_LAYERS_SUCCESS';
export const GET_SPATIAL_LAYERS_FAILED = 'GET_SPATIAL_LAYERS_FAILED';
export const GET_LATEST_ACTIVE_SPATIAL_LAYERS =
  'GET_LATEST_ACTIVE_SPATIAL_LAYERS';
export const SET_ACTIVE_CRG_OBJECT = 'SET_ACTIVE_CRG_OBJECT';
export const SET_ACTIVE_CRG_OBJECT_FLOOR = 'SET_ACTIVE_CRG_OBJECT_FLOOR';
export const TOGGLE_SPATIAL_LAYER = 'TOGGLE_SPATIAL_LAYER';
export const TOGGLE_SPATIAL_LAYER_GROUP = 'TOGGLE_SPATIAL_LAYER_GROUP';
export const UPDATE_DYNAMIC_LAYER = 'UPDATE_DYNAMIC_LAYER';
export const UPDATE_DISABLED_DYNAMIC_LAYERS = 'UPDATE_DISABLED_DYNAMIC_LAYERS';

// DEEP LINK
export const CREATE_DEEP_LINK_START = 'CREATE_DEEP_LINK_START';
export const CREATE_DEEP_LINK_SUCCESS = 'CREATE_DEEP_LINK_SUCCESS';
export const CREATE_DEEP_LINK_FAILED = 'CREATE_DEEP_LINK_FAILED';

// AVIVE AED
export const INACTIVATE_AVIVE_REQUEST = 'INACTIVATE_AVIVE_REQUEST';

export const SET_STATIC_SPATIAL_OBJECT_ACTIVE_STATUS =
  'SET_STATIC_SPATIAL_OBJECT_ACTIVE_STATUS';
export const SET_STATIC_SPATIAL_OBJECT_INACTIVE_STATUS =
  'SET_STATIC_SPATIAL_OBJECT_INACTIVE_STATUS';

// SPATIAL LAYERS - Optimized endpoints
export const GET_SPATIAL_OBJECTS_SUMMARY_SUCCESS =
  'GET_SPATIAL_OBJECTS_SUMMARY_SUCCESS';
export const GET_SPATIAL_OBJECTS_SUMMARY_FAILURE =
  'GET_SPATIAL_OBJECTS_SUMMARY_FAILURE';
export const FETCH_SPATIAL_OBJECT_DETAILS_START =
  'FETCH_SPATIAL_OBJECT_DETAILS_START';
export const GET_SPATIAL_OBJECT_DETAILS_SUCCESS =
  'GET_SPATIAL_OBJECT_DETAILS_SUCCESS';
export const FETCH_SPATIAL_OBJECT_DETAILS_FAILED =
  'FETCH_SPATIAL_OBJECT_DETAILS_FAILED';
